import { useState, useLayoutEffect, useEffect, useRef } from "react";
import { signOut } from "next-auth/react";
import { useRouter } from "next/router";
import Link from "next/link";
import styles from "./styles/Nav.module.css";

const TOP_THRESHOLD = 188;
const NAV_CONFIG = [
  {
    name: "Order History",
    value: "/account/orders",
  },
  {
    name: "Preferences",
    value: "/account/preferences",
  },
];

export const Nav = () => {
  const router = useRouter();
  const ref = useRef();
  const [scrollTop, setScrollTop] = useState(0);
  const [selected, setSelected] = useState();

  // Set selected nav item
  useEffect(() => {
    NAV_CONFIG.map((link) => {
      if (router.route === link.value) {
        setSelected(link.name);
      }
    });
  }, []);

  // Center the nav item on mobile
  useEffect(() => {
    const index = NAV_CONFIG.findIndex((link) => link.name === selected);
    const position = (index + 2) / (NAV_CONFIG.length + 1);
    const percent = position * ref.current.scrollLeftMax;
    const margin = 32 * (index + 1);

    ref.current.scrollLeft = percent - margin;
  }, [selected]);

  // Used to add the underline to the nav when
  // position:sticky is in effect
  useLayoutEffect(() => {
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  const navStyles = `
    ${styles.nav}
    ${scrollTop > TOP_THRESHOLD ? styles.navUnderline : ""}
  `;

  return (
    <nav className={navStyles} ref={ref}>
      <ul className={styles.list}>
        <li className={styles.title}>Your Account:</li>
        {NAV_CONFIG.map((link) => (
          <li key={link.name} className={styles.listItem}>
            <Link key={link.name} href={link.value}>
              {selected === link.name ? (
                <a className={styles.selected}>{link.name}</a>
              ) : (
                <a>{link.name}</a>
              )}
            </Link>
          </li>
        ))}
        <li className={styles.listItem}>
          <button onClick={() => { signOut(); window.location.href = "https://checkout.kotn.com/account/logout"}}>Sign Out</button>
        </li>
      </ul>
    </nav>
  );
};
